/**
 * Faz JSON.parse seguro de um valor do localStorage.
 * Retorna o objeto parseado ou o fallback fornecido caso o valor seja
 * inválido, ausente, ou a string literal "undefined"/"null".
 *
 * Se o valor estiver corrompido, remove a chave do localStorage para
 * evitar loops de erros em re-renders.
 *
 * @param {string} key - Chave do localStorage
 * @param {*} fallback - Valor padrão retornado em caso de erro (default: null)
 * @returns {*} Objeto parseado ou fallback
 */
export function safeParseJSON(key, fallback = null) {
  try {
    const raw = localStorage.getItem(key);
    if (raw == null || raw === "undefined" || raw === "null" || raw === "") {
      // Limpa valor corrompido para não reaparecer em próximas leituras
      if (raw === "undefined" || raw === "null") {
        localStorage.removeItem(key);
      }
      return fallback;
    }
    return JSON.parse(raw);
  } catch (e) {
    console.warn(
      `[safeParseJSON] Valor inválido no localStorage para "${key}". Removendo.`,
      e
    );
    localStorage.removeItem(key);
    return fallback;
  }
}
